var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var Flickity = require('flickity');

/**
 * Initialize Carousel for each Pick Category in Picks landing, mobile view.
 * 
 * @param el
 * @constructor
 */
function PicksCategory(el) {
  this.el = el;
  this.$el = $(el);

  var galleryElems = el.querySelectorAll('.picks-category__slider');

  for ( var i = 0, len = galleryElems.length; i < len; i++ ) {
    var galleryElem = galleryElems[i];
    new Flickity( galleryElem, {
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      freeScroll: true,
      watchCSS: true
    });
  }

}

module.exports = PicksCategory;